import { RouteObject } from 'react-router-dom';

const projectDetailsWizardRoutes: RouteObject[] = [
  {
    path: '*',
    id: 'project-details-wizard-root',
    async lazy() {
      const PreviewTemplate = await import('./project-details-wizard.view');
      return { Component: PreviewTemplate.default };
    },
    children: [
      {
        path: 'webinar-and-allhands/*',
        id: 'project-details-wizard-webinar-and-allhands',
        async lazy() {
          const PreviewTemplate = await import('./wizard/webinar-and-allhands-wizard/webinar-and-allhands-wizard.view');
          return { Component: PreviewTemplate.default };
        },
      },
      {
        path: 'events-and-others/*',
        id: 'project-details-wizard-events-and-others',
        async lazy() {
          const PreviewTemplate = await import('./wizard/events-and-others-wizard/events-and-others-wizard.view');
          return { Component: PreviewTemplate.default };
        },
      },
      {
        path: 'on-demand/*',
        id: 'project-details-wizard-on-demand',
        async lazy() {
          const PreviewTemplate = await import('./wizard/on-demand-wizard/on-demand-wizard.view');
          return { Component: PreviewTemplate.default };
        },
      },
    ],
  },
];

export default projectDetailsWizardRoutes;
